/**
 * @module index
 */

import { TelemetryProvider } from 'owa-actionable-message-v2';
import logTelemetry from './api/logTelemetry';

const telemetryProvider: TelemetryProvider = {
    logTelemetry: logTelemetry,
};

export { telemetryProvider };
export { default as getTelemetryData } from './utils/getTelemetryData';
export { default as getClientVersion } from './utils/getClientVersion';
